(() => {
  const newsletterForm = document.getElementById('footer-newsletter')
  const emailInput = newsletterForm?.querySelector('input[name="contact[email]"]')

  if (!newsletterForm || !emailInput) {
    return
  }

  const hostname = window.location.hostname
  const isLocalEnv = hostname === 'localhost' || hostname === '127.0.0.1'
  const bffUrl = isLocalEnv
    ? 'http://127.0.0.1:3266/'
    : 'https://bff.taelor.co/'

  const getCustomerInfoWithoutAuthByEmail = async (email) => {
    const queryParams = new URLSearchParams()
    queryParams.set('email', email)

    const response = await fetch(
      `${bffUrl}shopify/customer-no-auth?${queryParams.toString()}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    if (!response.ok) {
      throw new Error(`Failed to load customer info: ${response.status}`)
    }

    const { data, error } = await response.json()
    if (error) {
      if (error === 'Customer not found') {
        return null
      }

      throw new Error(error)
    }

    return data
  }

  let isValidating = false
  let skipValidationOnce = false
  const submitButton = newsletterForm.querySelector('button[type="submit"]')

  newsletterForm.addEventListener(
    'submit',
    async (event) => {
      if (skipValidationOnce) {
        skipValidationOnce = false
        return
      }

      event.preventDefault()
      event.stopPropagation()
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation()
      }

      if (isValidating) {
        return
      }

      const email = emailInput.value?.trim()
      if (!email) {
        skipValidationOnce = true
        if (typeof newsletterForm.requestSubmit === 'function') {
          newsletterForm.requestSubmit(submitButton || undefined)
          return
        }

        HTMLFormElement.prototype.submit.call(newsletterForm)
        return
      }

      isValidating = true

      try {
        const customerInfo = await getCustomerInfoWithoutAuthByEmail(email)

        if (customerInfo) {
          window.alert(
            'This email is already registered. Please sign in with this email.'
          )
          return
        }

        skipValidationOnce = true
        if (typeof newsletterForm.requestSubmit === 'function') {
          newsletterForm.requestSubmit(submitButton || undefined)
          return
        }

        HTMLFormElement.prototype.submit.call(newsletterForm)
      } catch (error) {
        window.alert('Unable to verify this email right now. Please try again.')
      } finally {
        isValidating = false
      }
    },
    true
  )
})()
